<template>
  <div class="estimator">
    <span class="pre">Shipping charge for</span>
    <form class="form">
      <label class="field">
        <div class="input input--dropdown">
          <select
            v-model="selectedCountry"
            class="input__element input__element--dropdown"
          >
            <option
              v-for="{ name, countrycode } in costs"
              :key="countrycode"
              :value="countrycode"
            >
              {{ name }}
            </option>
          </select>
        </div>
      </label>
    </form>
    <span v-if="returnCost" class="post">
      will cost approximately
      <strong>{{ $filters.toCurrency(returnCost, currencyCode) }}</strong>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "ReturnsEstimator",
  data() {
    return {
      selectedCountry: null,
    };
  },
  computed: {
    ...mapGetters("app", ["currencyCode"]),
    costs() {
      if (!this.currencyCode) {
        return null;
      }

      const currency = this.currencyCode;
      const json = require(`@/assets/json/return-costs-${currency}.json`);
      const sorted = json.sort((a, b) => a["countrycode"] - b["countrycode"]);

      return sorted || null;
    },
    returnCost() {
      const costs = this.costs;
      if (!costs) {
        return null;
      }

      const costObj = costs.find(({ countrycode }) => {
        return countrycode === this.selectedCountry;
      });

      return costObj?.cost || null;
    },
  },
  watch: {
    currencyCode(val) {
      this.setDefaultCountry(val);
    },
  },
  mounted() {
    this.setDefaultCountry(this.currencyCode);
  },
  methods: {
    setDefaultCountry(val) {
      const currencyToCountryCode = {
        gbp: "GB",
        usd: "USD",
        aud: "AU",
      };
      this.selectedCountry = currencyToCountryCode[val] || null;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/form";

.estimator {
  background-color: $color-grey-light;
  padding: 30px 20px;
  text-align: center;

  @include respond-above(md) {
    padding: 40px;
    background-color: $color-white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .pre,
  .post {
    display: block;
    font-size: 12px;
  }

  .pre {
    margin-bottom: 10px;

    @include respond-above(md) {
      margin-bottom: 0;
    }
  }

  .post {
    margin-top: 10px;

    @include respond-above(md) {
      margin-top: 0;
    }
  }

  .form {
    @include respond-above(md) {
      width: 30%;
      max-width: 280px;
      min-width: 160px;
    }
  }

  .input--dropdown {
    @include respond-above(md) {
      margin-bottom: 0;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}
</style>
